// extracted by mini-css-extract-plugin
export default {"HomeBlock":"home_HomeBlock__VkKrF","text":"home_text__9mDNN","background":"home_background__zOWEq","iconStar":"home_iconStar__kEagV","bgLine":"home_bgLine__PRcXk"};